<div class="print-errors margin-top-12 margin-bottom-8" *ngIf="control.invalid && (control.touched || control.dirty)">
  <ul class="error-list">
    <li *ngFor="let message of errorMessages">
      {{message}}
    </li>
  </ul>
</div>
